import { Outlet } from 'react-router-dom'
import { Auth0ProviderWithRedirectCallback } from '~/Auth0ProviderWithRedirectCallback'
import MfaProtection from '../features/auth/mfa/MfaProtection'
import { useChatlioLocalization } from '../hooks/useChatlioLocalization'

export const AppLayout: React.FC = () => {
  // Initialize Chatlio with correct localization for all routes
  useChatlioLocalization()

  return (
    <Auth0ProviderWithRedirectCallback>
      <MfaProtection>
        <Outlet />
      </MfaProtection>
    </Auth0ProviderWithRedirectCallback>
  )
}
